import { Button, Link } from '@utilitywarehouse/hearth-react';
import { DownloadSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import React from 'react';

import './style.scss';

interface DocumentProps {
  name: string;
  url: string;
  onClick: (name: string) => void;
}

const DocumentLink: React.FC<DocumentProps> = ({ name, url, onClick }) => {
  return (
    <Button asChild variant="ghost" size="sm" paddingNone>
      <Link
        onClick={() => onClick(name)}
        href={url}
        target="_blank"
        rel="noreferrer noopener"
        hideOpenIcon
      >
        <DownloadSmallIcon />
        <span className="document-link__name">{name}</span>
      </Link>
    </Button>
  );
};
export { DocumentLink };
